import {Alert, type AlertProps} from '@gfiber/pixel-party';
import {Snackbar} from '@pixel-party';
import type React from 'react';
import {useCallback, useState} from 'react';

export interface NotificationState {
  isShowingNotification: boolean;
  showNotification: () => void;
  dismissNotification: () => void;
  setShowNotification: (value: boolean) => void;
}

export const useNotificationState = (): NotificationState => {
  const [isShowingNotification, setShowNotification] = useState(false);
  const showNotification = useCallback(
    () => setShowNotification(true),
    [setShowNotification],
  );
  const dismissNotification = useCallback(
    () => setShowNotification(false),
    [setShowNotification],
  );

  return {
    isShowingNotification,
    showNotification,
    dismissNotification,
    setShowNotification,
  };
};

export enum TransitionType {
  Slide = 'slide',
  Grow = 'grow',
  Fade = 'fade',
}

export interface NotificationTooltipProps {
  /** By default without alert component */
  severity?: AlertProps['severity'];
  /** By default filled */
  variant?: AlertProps['variant'];
  /** By default slide */
  transition?: TransitionType;
  onClose?: (event?: object) => void;
  children?: React.ReactElement | React.ReactElement[];
  autoHideDuration?: number | undefined;
  open?: boolean;
}

export const NotificationTooltip = ({
  onClose,
  severity,
  variant = 'filled',
  children,
  autoHideDuration = 5000,
  ...props
}: NotificationTooltipProps) => (
  <Snackbar
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    {...props}
  >
    {severity ? (
      <Alert
        onClose={onClose}
        severity={severity}
        variant={variant}
      >
        {children}
      </Alert>
    ) : (
      children
    )}
  </Snackbar>
);
